import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box } from '@hivewatch/dark'

import { Notification } from '@/graphql/appsync-notifications'
import { roleName } from '@/utils/roles'

import { getNotificationToastTokens } from '../styles/tokens'

export const ClearNotificationTitle = ({
  notification,
}: {
  notification: Notification
}) => {
  const { t } = useTranslation()
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <Box color={tokens.textPrimary} lineClamp={2} textStyle='body-bold'>
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='ClearNotificationTitle:title'
      >
        {roleName(notification?.incidentActionUserRole)}{' '}
        {notification?.incidentActionUserName}{' '}
      </Box>{' '}
      {t('common:notification_cleared')}{' '}
      <Box
        as='span'
        color={tokens.incidentLink}
        data-testid='ClearNotificationTitle:details'
      >
        {notification?.incidentDisplayId} {notification?.incidentName}
      </Box>
    </Box>
  )
}
